import { useTranslation } from 'react-i18next'
import PageHeading from 'components/atoms/PageHeading'
import PageBody from 'components/atoms/PageBody'
import SetupConstantForm from 'components/organisms/forms/SetupConstantForm'
import {
  useGET_schoolSetupAssessmentTypesQuery,
  usePUT_schoolSetupAssessmentTypeEnableMutation,
  usePUT_schoolSetupAssessmentTypeDisableMutation,
  useGET_schoolSetupSubmissionTypesQuery,
  usePUT_schoolSetupSubmissionTypeEnableMutation,
  usePUT_schoolSetupSubmissionTypeDisableMutation,
  useGET_schoolSetupScoreTypesQuery,
  usePUT_schoolSetupScoreTypeEnableMutation,
  usePUT_schoolSetupScoreTypeDisableMutation, 
} from 'redux/api/setupApi'

const SetupConstantCrudPage = ({type}) => {
  const { t } = useTranslation()

  const map = {
    'assessment-types': {
      component: null,
      listQuery: useGET_schoolSetupAssessmentTypesQuery,
      enableMutation: usePUT_schoolSetupAssessmentTypeEnableMutation,
      disableMutation: usePUT_schoolSetupAssessmentTypeDisableMutation,
    },
    'submission-types': {
      component: null,
      listQuery: useGET_schoolSetupSubmissionTypesQuery,
      enableMutation: usePUT_schoolSetupSubmissionTypeEnableMutation,
      disableMutation: usePUT_schoolSetupSubmissionTypeDisableMutation,
    },
    'score-types': {
      component: null,
      listQuery: useGET_schoolSetupScoreTypesQuery,
      enableMutation: usePUT_schoolSetupScoreTypeEnableMutation,
      disableMutation: usePUT_schoolSetupScoreTypeDisableMutation,
    },
  }

  const {data: data} = map[type].listQuery()

  return (
      map[type] &&  <>
          
          <PageBody>
              {data?.map(entity => <SetupConstantForm 
                key={entity.option}
                type={type} 
                entity={entity}
                enableMutation={map[type].enableMutation}
                disableMutation={map[type].disableMutation}
                />)}
          </PageBody>  
        </>
   
  )
}
export default SetupConstantCrudPage
